import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChatState } from './chat.state';

export const selectChatState = createFeatureSelector<ChatState>('chat');

// Basic selectors
export const selectConversations = createSelector(
  selectChatState,
  (state: ChatState) => state.conversations
);

export const selectSelectedConversationId = createSelector(
  selectChatState,
  (state: ChatState) => state.selectedConversationId
);

export const selectConversationsSortedByTimestamp = createSelector(
  selectConversations,
  conversations =>
    [...conversations].sort((a, b) => b.last_message_timestamp - a.last_message_timestamp)
);
